export interface IFormValues {
  endpointUrl: string;
  endpointUsername: string;
  endpointPassword: string;
  selectedAreas: Array<string>;
}
export interface IFeed {
  feedTypeName: string;
  description: string;
  subscriptionFeedTypeID: string;
  subscriptionId: string;
}

export interface IFormProps {
  feedForm?: IFormValues;
}

export interface IHistory {
  data: IFeed;
  emailAddress: string;
  action: string;
  userId: string;
}

/**
 * Enum for alert type
 */
export enum AlertType {
  Success = 'success',
  Error = 'error',
}

/**
 * Enum for alert type
 */
export enum ActionType {
  Add = 'add',
  Edit = 'edit',
}
